export const AHOC_REFERENCE_DATA =
"allsureHomeClaim/referenceData/";

export const AHOC_REFERENCE_DATA_SET_VALUE =
AHOC_REFERENCE_DATA+"setValue/";



export const setAhocReferenceDataValue =(value)=>({type: AHOC_REFERENCE_DATA_SET_VALUE, value})
